import React, { useEffect, useState, useRef } from 'react';
import axios from "axios";
import { ExpandMore, ExpandLess, Add, Remove } from '@mui/icons-material';
//import io from 'socket.io-client';
import { useSelector } from "react-redux";
import {  acknowledgealarmeventrecord, getHistoricalAlarms, getplantview, addcommentalarmeventrecord, getSnoozeConfig, postsnoozeAlarmConfig, getdevicetags1, getGroupTree  } from '../../Restclient/datacollection';
import CustomTableHeading from '../CommonComponents/CustomTableHeading';
import CustomTableMetric from '../CommonComponents/CustomTableMetric';
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomButton from "../CommonComponents/CustomButton";
import { Box, Stack, Checkbox} from "@mui/material";
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import '../../cssfiles/homepage.css';
import TextField from '@mui/material/TextField';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Select} from "@mui/material";
import CustomDialogBox from "../CommonComponents/CustomDialogBox.jsx";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
FormControl,
InputLabel,
IconButton,
FormGroup,
FormControlLabel
} from '@mui/material';
import TagSelection from './TagSelection';
import DeviceSelection from './DeviceSelection';
import CustomActionButton from "../CommonComponents/CustomActionButton";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import SeverityAlert from "../../images/SeverityAlert.svg";
import Chart from "react-apexcharts";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import LK_Loading from '../../images/LK_Loading.gif';
import {
  Menu,
  MenuItem,
} from '@mui/material';
import BlinkingSevereIcon from '../CommonComponents/BlinkingSevereIcon';
import SevereIcon from '../CommonComponents/SevereIcon';
import BlinkingAlarmIcon from '../CommonComponents/BlinkingAlarmIcon';
import AlarmIcon from '../CommonComponents/AlarmIcon';
import BlinkingWarningIcon from '../CommonComponents/BlinkingWarningIcon';
import WarningIcon from '../CommonComponents/WarningIcon';
import InformationIcon from '../CommonComponents/InformationIcon';
import BlinkingInformationIcon from '../CommonComponents/BlinkingInformationIcon';
import SwitchComponent from '../Dashboards/Graphs/Switch/SwitchComponent';
import { useDispatch} from "react-redux";
import { setPage } from "../../store/pageselect_data";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {updatetreepathselected,updatetabpath, updateselectedtreedashboard} from "../../store/mainpage_data";
import { updatealarmarray} from "../../store/alarm_data";
const _ = require('lodash');


var switchstate = true;

// Sample tree data structure
// const initialTreeData = [
//   {
//     id: '1',
//     label: 'Root Node',
//     alertrules: ['Rule A', 'Rule B'],
//     notificationrules: ['Notification 1'],
//     reportrules: ['Report X'],
//     expanded: false,
//     children: [
//       {
//         id: '1-1',
//         label: 'Child Node 1',
//         alertrules: ['Rule C'],
//         notificationrules: [],
//         reportrules: ['Report Y'],
//         expanded: false,
//         children: [
//           {
//             id: '1-1-1',
//             label: 'Grandchild Node 1',
//             alertrules: [],
//             notificationrules: ['Notification 2'],
//             reportrules: [],
//             expanded: false,
//             children: []
//           }
//         ]
//       },
//       {
//         id: '1-2',
//         label: 'Child Node 2',
//         alertrules: ['Rule D', 'Rule E'],
//         notificationrules: ['Notification 3'],
//         reportrules: [],
//         expanded: false,
//         children: []
//       }
//     ]
//   },
//   {
//     id: '2',
//     label: 'Second Root',
//     alertrules: [],
//     notificationrules: [],
//     reportrules: ['Report Z'],
//     expanded: false,
//     children: [
//       {
//         id: '2-1',
//         label: 'Another Child',
//         alertrules: ['Rule F'],
//         notificationrules: [],
//         reportrules: [],
//         expanded: false,
//         children: []
//       }
//     ]
//   }
// ];

export default function AlarmDashboard(props){
    const dispatch = useDispatch();
    const [alarmEvents, setAlarmEvents] = useState([]);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const tagdetails = useSelector((state) => state.mainpagedata.tagdetailsobject)
    const devicedetails = useSelector((state) => state.mainpagedata.devicedetailsobject)
    const username = useSelector((state) => state.logindata.username)
    const livealarmarray = useSelector((state) => state.alarmdata.livealarmarray)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    const selecteddates_dashboard = useSelector((state) => state.mainpagedata.selecteddates_dashboard)
    const [energyconsumersaver, setEnergyconsumersaver] = useState(switchstate);
    const fetchHistoricalAlerts = useSelector((state) => state.alarmdata.fetchHistoricalAlerts);
    const [stateVarConsumerSaver, setStateVarConsumerSaver] = useState(true);
    const [loading, setLoading] = useState(true);
    const [openDialog, setOpenDialog] = useState(false)
    const [opencommentDialog, setOpennCommentDialog] = useState(false)
    const themechange = useSelector((state) => state.themedata.theme)
    const [data, setData] = useState([]);
    const alarmcurrentaudiostate = useSelector((state) => state.alarmdata.alarmaudiostate)
    //const selectedNodes = useSelector((state) => state.alarmdata.selectedNodes)
    const [selectedNodes, setSelectedNodes] = useState([]); // Track selected nodes
    const [anchorEl, setAnchorEl] = useState(null);
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate) 
    const [filteredAlarms, setFilteredAlarms] = useState([]);
    const [filteredHistAlarms, setFilteredHistAlarms] = useState([]);
    const [countAlarms, setCountsInAlarms] = useState({
        totalalarmscount:0,
        unackalarmscount:0,
    });
    const [selectedGroup, setSelectedGroup] = useState(''); // Selected group
    const [treeData, setTreeData] = useState({});
    const [selectedNode, setSelectedNode] = useState(null);
    const [openAlarmUpdatedandSaved, setopenAlarmUpdatedandSaved] = useState(false);
    const [options, setOptions] = useState({});
    const [series, setSeries] = useState([]);
    //const [tagdetails, setTagDetails] = useState('');
    //const [devicedetails, setDeviceDetails] = useState('');
    const [dashboardstagsmapping, setDashboardstagsmapping] = useState({});
    //const socketalarm = useSelector((state) => state.alarmdata.alarmsocket)
    const [plantviewlist, setPlantviewlist] = useState([]);
    const [selectedAlarm,setSelectedAlarm] = useState(null);
    const [selectedCommentAlarm,setSelectedCommentAlarm] = useState(null);
    const [commentadded,setCommentAddedOnAlarm] = useState('');
    //const [tagDeviceMappings,settagDeviceMappings] = useState({})
    const [config, setConfig] = useState({
        enableAudioForHigh: true,
        enableAudioForMedium: false,
        enableAudioForLow: false
    });
    const [errMessage, setErrMessage] = useState('');
    const [errExists, setErrExists] = useState(false);
    const [groups, setGroups] = useState({}); // Store groups with their tree structures
    const [openAddNodeDialog, setOpenAddNodeDialog] = useState(false); // Dialog for adding nodes
    const [newNodeName, setNewNodeName] = useState(''); // Name for the new subnode
    const [snoozeDetails, setSnoozeDetails] = useState([]); // Snooze details for the project
    const [selectedAlerts, setSelectedAlerts] = useState([]); // Alerts selected for snoozing
    const [openSnoozeModal, setOpenSnoozeModal] = useState(false); // Snooze modal state
    const [selectedDuration, setSelectedDuration] = useState(""); // Selected snooze duration
    const [pagesize, setPagesize] = useState(370)
    const [openGrouping,setGrouping] = useState(false);
    const [openTagDialog,setOpenTagDialog] = useState(false);
    const [openDeviceDialog,setOpenDeviceDialog] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]); // Selected tags for 
    const [selectedDevices, setSelectedDevices] = useState([]); // Array of selected device IDs
     const predefinedDurations = [
        { label: "5 seconds", value: 5 },
        { label: "5 minutes", value: 300 },
        { label: "10 minutes", value: 600 },
    ];
    const [sortColumn, setSortColumn] = useState(""); // Column to sort by
    const [sortOrder, setSortOrder] = useState("asc"); // Sorting order (asc/desc)
    const [projectID, setprojectID] = useState("");
    const [ID, setID] = useState("");
    const [assetdata,setAssetData] = useState(null);
    const [assetdataerror,setAssetDataError] = useState(false);
    function handleAlertSelection(alertId){
        setSelectedAlerts((prev) =>
        prev.includes(alertId)
            ? prev.filter((id) => id !== alertId)
            : [...prev, alertId]
        );
    };
    const { PermissionsArray: usrPrmns } = useSelector((state) => state.logindata.userdetails);
    // Add this state to force re-render when snooze expires
    const [snoozeRefreshTrigger, setSnoozeRefreshTrigger] = useState(0);

    // Add this useEffect to trigger re-render when snooze expires
    useEffect(() => {
        // Check every 5 seconds to see if any snooze has expired
        const interval = setInterval(() => {
            // Increment the trigger to force re-evaluation
            setSnoozeRefreshTrigger(prev => prev + 1);
        }, 5000);

        return () => clearInterval(interval);
    }, [snoozeDetails]);

    useEffect(() => {
        if(overviewstate) {
            setPagesize(323)
        } else {
            setPagesize(288)
        }
        if (usrPrmns.includes("PACF68")) {
            getdevicetags1(selectedprojectname,userdetails.Projectlist, assetcallback)
        }
    },[overviewstate,selectedprojectname])

    const assetcallback = (res,status) => {
        if(status == 200){
            setAssetData(res?.data);
            setAssetDataError(false);
        }else{
            setAssetData({"devices":[]})
            setAssetDataError(true);
        }
    };
    
    // const handleConfirmSnooze = () => {
    // }

    const getAllDashboardsTagsMappingcallback = (res) => {
        setDashboardstagsmapping(res?.dashboardtagmapping?.dashboardlist)
    }

    // Build path for a node (similar to your buildNodePath function)
  const buildNodePath = (tree, stopNodeId, path = []) => {
    if (!tree) return [];
    
    // Add current node to path
    const currentPath = [...path, tree.label];
    
    // If we found the target node, return the path
    if (tree.id === stopNodeId) {
      return currentPath;
    }
    
    // Search in children
    if (tree.children && tree.children.length > 0) {
      for (let child of tree.children) {
        const resultPath = buildNodePath(child, stopNodeId, currentPath);
        if (resultPath.length > 0) {
          return resultPath;
        }
      }
    }
    
    return [];
  };

  // Find path for any node in the entire tree
  const findNodePath = (nodeId) => {
    for (let rootNode of treeData) {
      const path = buildNodePath(rootNode, nodeId);
      if (path.length > 0) {
        return path.join(' > ');
      }
    }
    return '';
  };

    // Handle group selection
    const handleGroupChange = (event) => {
        const groupName = event.target.value;
        setSelectedGroup(groupName);
        setTreeData(groups[groupName] || []); // Load tree for selected group
    };

  // Handle node selection
    const handleNodeSelection = (node) => {
      // Only allow one node to be selected at a time
        setSelectedNodes((prevSelected) => {
            const isSelected = prevSelected.length > 0 && prevSelected[0].id === node.id;
            const updatedNodes = isSelected ? [] : [node];
            //dispatch(updateSelectedNodes(updatedNodes));
            return updatedNodes;
        });
    };

   const handleExpandClick = (nodeId) => {
        const updateExpansion = (nodes) => {
            return nodes.map((node) => {
                if (node.id === nodeId) {
                    const expanded = !node.expanded;
                    let children = node.children;
                    if (!expanded) {
                        // Collapse all child nodes recursively
                        const collapseChildren = (childNodes) => {
                            return (childNodes || []).map((child) => ({
                                ...child,
                                expanded: false,
                                children: collapseChildren(child.children || []),

                            }));
                        };
                        children = collapseChildren(node.children || []);
                    }
                    return {
                        ...node,
                        expanded,
                        children,
                    };
                } else if (node.children) {
                    return {
                        ...node,
                        children: updateExpansion(node.children)
                    };
                }
                return node;
            });
        };
        setTreeData(updateExpansion(treeData));
   };

   const renderTree = (nodes) => {
      return (
        <ul style={{ listStyleType: "none", paddingLeft: "20px", textAlign: "left" }}>
          {nodes.map((node) => {
              const nodePath = buildNodePath(treeData[0], node.label); // Get the path for the current node
              return (
                   <li key={node.id} style={{ marginBottom: "10px" }}>
                        <div key={node.id}>
                                <IconButton size="small" onClick={() => handleExpandClick(node.id)}>
                                    {node.expanded ? <ExpandLess style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C'}} /> : <ExpandMore style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C'}} />}
                                </IconButton>
                                <Checkbox
                                    checked={selectedNodes.some((selectedNode) => selectedNode.id === node.id)}
                                    onChange={() => handleNodeSelection(node)}
                                    sx={{
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': { fontSize: '20px' },
                                    }}
                                />
                                {node.label}
                                {node.expanded && (
                                    <>
                                        {/* Alerts Section */}
                                        <div style={{ marginLeft: '70px', marginBottom: '8px' }}>
                                            <div><strong>Alert Rules:</strong></div>
                                            {node.alertrules.length > 0 ? (
                                                node.alertrules.map((rule, index) => (
                                                    <li key={index}>
                                                        {devicedetails[tagdetails[rule]?.DeviceID]?.Name+":"+tagdetails[rule]?.Alias} - Path: {nodePath}
                                                    </li>
                                                ))
                                            ) : (
                                                <div style={{ color: '#888', fontStyle: 'italic' }}>No alert rules</div>
                                            )}
                                        </div>
                                        {/* Reports Section */}
                                        <div style={{ marginLeft: '70px', marginBottom: '8px' }}>
                                            <div><strong>Report Rules:</strong></div>
                                            {node.reportrules.length > 0 ? (
                                                node.reportrules.map((rule, index) => (
                                                    <li key={index}>
                                                        {rule} - Path: {nodePath}
                                                    </li>
                                                ))
                                            ) : (
                                                <div style={{ color: '#888', fontStyle: 'italic' }}>No report rules</div>
                                            )}
                                        </div>
                                        {/* Notification Section */}
                                        <div style={{ marginLeft: '70px', marginBottom: '8px' }}>
                                                <div><strong>Notification Rules:</strong></div>
                                                {node.notificationrules.length > 0 ? (
                                                    node.notificationrules.map((rule, index) => (
                                                        <li key={index}>
                                                            {rule} - Path: {nodePath}
                                                        </li>
                                                    ))
                                                ) : (
                                                    <div style={{ color: '#888', fontStyle: 'italic' }}>No notification rules</div>
                                                )}
                                        </div>
                                        {/* Render children recursively */}
                                        {renderTree(node.children)}
                                    </>
                                )}
                                {/* Add buttons for subnode and rule actions */}
                            <br />
                        </div>
                   </li>
              )
          })}
        </ul>
      );
    };

    // Render rules section
    const renderRulesSection = (title, rules, nodeId) => {
        const nodePath = findNodePath(nodeId);
        return (
            <div className="ml-8 mb-2">
                <div className="font-semibold text-sm text-gray-700">{title}:</div>
                {rules.length > 0 ? (
                    <ul className="ml-4">
                        {rules.map((rule, index) => (
                            <li key={index} className="text-sm text-gray-600 flex justify-between items-center">
                                <span>{rule} - Path: {nodePath}</span>
                                <button 
                                className="ml-2 px-2 py-1 text-xs bg-red-100 text-red-600 rounded hover:bg-red-200"
                                onClick={() => console.log(`Remove ${title} rule: ${rule} from node ${nodeId}`)}
                                >
                                Remove
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="ml-4 text-sm text-gray-400 italic">No {title.toLowerCase()}</div>
                )}
            </div>
        );
    };

    // Render tree recursively
    var dashboardpath = [];

    const plantviewcallback = (res) => {
        var plantarray = res["plantview"][0];
        setPlantviewlist(plantarray);
        //plantpathcollect(plantarray);
    }

    function handleFilterGrouping(){
        setGrouping(false);
    }

    function handleCloseGrouping(){
        setGrouping(false);
    }

    function handleFilterTag(){
        setOpenTagDialog(false);
    }

    function handleCloseFilterTag(){
        setOpenTagDialog(false);
    }

    function handleFilterDevice(){
        setOpenDeviceDialog(false);
    }

    function handleCloseFilterDevice(){
        setOpenDeviceDialog(false);
    }
    
     useEffect(()=>{
        if(props.checkfilterlist.checkedgroup){
            setGrouping(true)
        }
        if(props.checkfilterlist.checkedtag){
            setOpenTagDialog(true)
        }
        if(props.checkfilterlist.checkeddevice){
            setOpenDeviceDialog(true)
        }
    },[props.checkfilterlist.checkedgroup, props.checkfilterlist.checkedtag, props.checkfilterlist.checkeddevice,selectedprojectname])

    function handleConfirmationAlarmUpdatedandSaved(){
        setopenAlarmUpdatedandSaved(false)   
    }

    function handleCloseAlarmUpdatedandSaved(){
        setopenAlarmUpdatedandSaved(false);
    }

    function handleConfirmationErrorDialog(){
        setErrExists(false);
        setErrMessage('');
    }

    function handleCloseErrorDialog(){
        setErrExists(false);
        setErrMessage('');
    }


    
    const filteralarms = (alarm) => {
        if (!alarm || Object.keys(alarm).length === 0) {
            return false; // Return false if alarm is undefined or has no keys
        }

        const { checkedtag, checkeddevice, checkedunack, checkedactive,checkedgroup } = props.checkfilterlist;
        if(checkedgroup){
            let alertrules = [];
            if(Array.isArray(selectedNodes) && selectedNodes.length > 0){
                for (let i = 0; i < selectedNodes.length; i++) {
                    let currentalerts = selectedNodes[i].alertrules;
                    alertrules = [...alertrules, ...currentalerts];
                }
            }

            if (Array.isArray(alertrules) && alertrules.length > 0) {
                return alertrules.includes(alarm.TagID)
            }
        }  

        if(checkedtag){
            console.log("filteralarms selectedTags",selectedTags,"alarm.TagID",alarm.TagID)
            if(selectedTags.length > 0){
                return selectedTags.some(param => param.tagid === alarm.TagID)
            }else{
                return true
            }
        }

        if (checkeddevice) {
            if(selectedDevices.length === 0) {
                return true;
            }

            return selectedDevices.some(device =>
                Array.isArray(device.Parameters) &&
                device.Parameters.some(param => param.tagId === alarm.TagID)
            );
        }

        if (checkedunack && checkedactive) {
            return (alarm.State == 'active' && alarm.AcknowledgementStatus === false);
        } else if (!checkedunack && checkedactive) {
            return alarm.State == 'active';
        } else if (checkedunack && !checkedactive) {
            return alarm.AcknowledgementStatus === false;
        } else {
            return true; 
        }
    };

    useEffect(() => {
        //getTagDetailsInformationProjectwise('Pro-1',getTagDetailsInformationProjectwisecallback)
        //getDeviceDetailsInformationProjectwise('Pro-1',getDeviceDetailsInformationProjectwisecallback)
        if(data && data.length > 0 && energyconsumersaver == true){
            var totalalarmscountdata= data.length;
            var unackalarmscountdata= 0;
            var totalseverecount= 0;
            var totalalarmcount= 0;
            var totalwarningcount= 0;
            var totalinformationcount= 0;

            for(var i=0;i<data.length;i++){
                
                if(data[i] && data[i]?.AcknowledgementStatus == false){
                    unackalarmscountdata++;
                }

                if(data[i] && data[i].AlertClass){
                    if(data[i].AlertClass == '100'){
                        totalseverecount++;
                    }else if(data[i].AlertClass == '75'){
                        totalalarmcount++
                    }else if(data[i].AlertClass == '50'){
                        totalwarningcount++
                    }else if(data[i].AlertClass == '25'){
                        totalinformationcount++;
                    }
                }
                    
            }
           
            var optionsalarms = {
                chart: {
                    type: 'bar',
                    stacked: true,
                    //height:'16px',
                    stackType: '100%',
                    toolbar: {
                        show: false
                    },
                    offsetY: 10,
                    offsetX: -1,
                    //parentHeightOffset: '-100px',
                },
                grid: {
                    show: false,
                    padding: {
                        left: -16,
                        right: 0,
                        top: -20,
                        bottom: 0
                    }
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        // startingShape: "rounded",
                        // endingShape: "rounded",
                        //borderRadiusApplication:"start",
                        //borderRadiusWhenStacked:"all",
                        // borderRadius: 4,
                        horizontal: true,
                        dataLabels: {
                            position: 'center',
            
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                        return w.config.series[seriesIndex].data
                    },
                    style: {
                        colors: ['#000000'],
            
                    },
                },
                colors: ['var(--RedBaseColor)', 'var(--AmberBaseColor)', 'var(--YellowBaseColor)', 'var(--GreenBaseColor)'],
                stroke: {
                    width: 0,
                    colors: ['var(--Searchtext_muted)']
                },
                xaxis: {
                    show: false,
                    labels: {
                        show: false,
                        style: {
                            fontSize: '12px',
                            fontWeight: 400,
                            colors: "var(--GreyVariation_1)",
                            fontFamily: "Roboto",
                        }
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    }
                },
                yaxis: {
                    show: false,
                    labels: {
                        show: false,
                        style: {
                            fontSize: '12px',
                            fontWeight: 400,
                            colors: "var(--GreyVariation_1)",
                            fontFamily: "Roboto",
            
                        },
                        offsetX: -10
                    },
                },
                legend: {
                    show: false,
                    customLegendItems: ['Severe'+totalseverecount, 'Alarm'+totalalarmcount, 'Warning'+totalwarningcount, 'Information'+totalseverecount],
                    position: 'top',
                    fontSize: '12px',
                    fontWeight: 400,
                    width: '260',
                    horizontalAlign: "right",
                    //offsetX: 330,
                    // offsetY: -10,
                    labels: {
                        colors: "var(--PrimaryText)",
                    },
                    markers: {
                        width: 8,
                        height: 8,
                        radius: 8,
                    }
                }
            };
            var seriesalarms = [{
                data: [totalseverecount]
            },
            {
                data: [totalalarmcount]
            },
            {
                data: [totalwarningcount]
            },
            {
                data: [totalinformationcount]
            }];

            setOptions(optionsalarms)
            setSeries(seriesalarms)

            setCountsInAlarms({
                totalalarmscount:totalalarmscountdata,
                unackalarmscount:unackalarmscountdata
            })
            checkForAudioAlert([...data].sort((a,b)=> b.Timestamp - a.Timestamp), config);

            //data.sort((a,b)=> b.Timestamp - a.Timestamp)
            const filteredAlarmsArray = data.filter(filteralarms);

            //console.log("filtered alarm array shown in here",filteredAlarmsArray)
            setFilteredAlarms(filteredAlarmsArray);
        }else if(energyconsumersaver == false){
            var totalalarmscountdata= filteredHistAlarms.length;
            var unackalarmscountdata= 0;
            var totalseverecount= 0;
            var totalalarmcount= 0;
            var totalwarningcount= 0;
            var totalinformationcount= 0;

            for(var i=0;i<filteredHistAlarms.length;i++){
                if(filteredHistAlarms[i] && filteredHistAlarms[i]?.AcknowledgementStatus == false){
                    unackalarmscountdata++;
                }

                if(filteredHistAlarms[i] && filteredHistAlarms[i].AlertClass){
                    if(filteredHistAlarms[i].AlertClass == '100'){
                        totalseverecount++;
                    }else if(filteredHistAlarms[i].AlertClass == '75'){
                        totalalarmcount++
                    }else if(filteredHistAlarms[i].AlertClass == '50'){
                        totalwarningcount++
                    }else if(filteredHistAlarms[i].AlertClass == '25'){
                        totalinformationcount++;
                    }
                }
                    
            }
            
            var optionsalarms = {
                chart: {
                    type: 'bar',
                    stacked: true,
                    //height:'16px',
                    stackType: '100%',
                    toolbar: {
                        show: false
                    },
                    offsetY: 10,
                    offsetX: -1,
                    //parentHeightOffset: '-100px',
                },
                grid: {
                    show: false,
                    padding: {
                        left: -16,
                        right: 0,
                        top: -20,
                        bottom: 0
                    }
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        // startingShape: "rounded",
                        // endingShape: "rounded",
                        //borderRadiusApplication:"start",
                        //borderRadiusWhenStacked:"all",
                        // borderRadius: 4,
                        horizontal: true,
                        dataLabels: {
                            position: 'center',
            
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                        return w.config.series[seriesIndex].data
                    },
                    style: {
                        colors: ['#000000'],
            
                    },
                },
                colors: ['var(--RedBaseColor)', 'var(--AmberBaseColor)', 'var(--YellowBaseColor)', 'var(--GreenBaseColor)'],
                stroke: {
                    width: 0,
                    colors: ['var(--Searchtext_muted)']
                },
                xaxis: {
                    show: false,
                    labels: {
                        show: false,
                        style: {
                            fontSize: '12px',
                            fontWeight: 400,
                            colors: "var(--GreyVariation_1)",
                            fontFamily: "Roboto",
                        }
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    }
                },
                yaxis: {
                    show: false,
                    labels: {
                        show: false,
                        style: {
                            fontSize: '12px',
                            fontWeight: 400,
                            colors: "var(--GreyVariation_1)",
                            fontFamily: "Roboto",
            
                        },
                        offsetX: -10
                    },
                },
                legend: {
                    show: false,
                    customLegendItems: ['Severe'+totalseverecount, 'Alarm'+totalalarmcount, 'Warning'+totalwarningcount, 'Information'+totalseverecount],
                    position: 'top',
                    fontSize: '12px',
                    fontWeight: 400,
                    width: '260',
                    horizontalAlign: "right",
                    //offsetX: 330,
                    // offsetY: -10,
                    labels: {
                        colors: "var(--PrimaryText)",
                    },
                    markers: {
                        width: 8,
                        height: 8,
                        radius: 8,
                    }
                }
            };
            var seriesalarms = [{
                data: [totalseverecount]
            },
            {
                data: [totalalarmcount]
            },
            {
                data: [totalwarningcount]
            },
            {
                data: [totalinformationcount]
            }];

            setOptions(optionsalarms)
            setSeries(seriesalarms)

            setCountsInAlarms({
                totalalarmscount:totalalarmscountdata,
                unackalarmscount:unackalarmscountdata
            })
            checkForAudioAlert([...filteredHistAlarms].sort((a,b)=> b.Timestamp - a.Timestamp), config);
            //console.log("Kitchen Area AC 3 - Meter",projectfilteredarray, "userdetails",userdetails)
            //filteredHistAlarms.sort((a,b)=> b.Timestamp - a.Timestamp)
            //const filteredAlarmsArray = filteredHistAlarms.filter(filteralarms);
            //console.log("filtered alarm array shown in here",filteredAlarmsArray)

        }else{
            var optionsalarms = {
                chart: {
                    type: 'bar',
                    stacked: true,
                    //height:'16px',
                    stackType: '100%',
                    toolbar: {
                        show: false
                    },
                    offsetY: 10,
                    offsetX: -1,
                    //parentHeightOffset: '-100px',
                },
                grid: {
                    show: false,
                    padding: {
                        left: -16,
                        right: 0,
                        top: -20,
                        bottom: 0
                    }
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        // startingShape: "rounded",
                        // endingShape: "rounded",
                        //borderRadiusApplication:"start",
                        //borderRadiusWhenStacked:"all",
                        // borderRadius: 4,
                        horizontal: true,
                        dataLabels: {
                            position: 'center',
            
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                        return w.config.series[seriesIndex].data
                    },
                    style: {
                        colors: ['#000000'],
            
                    },
                },
                colors: ['var(--RedBaseColor)', 'var(--AmberBaseColor)', 'var(--YellowBaseColor)', 'var(--GreenBaseColor)'],
                stroke: {
                    width: 0,
                    colors: ['var(--Searchtext_muted)']
                },
                xaxis: {
                    show: false,
                    labels: {
                        show: false,
                        style: {
                            fontSize: '12px',
                            fontWeight: 400,
                            colors: "var(--GreyVariation_1)",
                            fontFamily: "Roboto",
                        }
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    }
                },
                yaxis: {
                    show: false,
                    labels: {
                        show: false,
                        style: {
                            fontSize: '12px',
                            fontWeight: 400,
                            colors: "var(--GreyVariation_1)",
                            fontFamily: "Roboto",
            
                        },
                        offsetX: -10
                    },
                },
                legend: {
                    show: false,
                    customLegendItems: ['Severe'+0, 'Alarm'+0, 'Warning'+0, 'Information'+0],
                    position: 'top',
                    fontSize: '12px',
                    fontWeight: 400,
                    width: '260',
                    horizontalAlign: "right",
                    //offsetX: 330,
                    // offsetY: -10,
                    labels: {
                        colors: "var(--PrimaryText)",
                    },
                    markers: {
                        width: 8,
                        height: 8,
                        radius: 8,
                    }
                }
            };
            var seriesalarms = [{
                data: [0]
            },
            {
                data: [0]
            },
            {
                data: [0]
            },
            {
                data: [0]
            }];

            setOptions(optionsalarms)
            setSeries(seriesalarms)

            setCountsInAlarms({
                totalalarmscount:0,
                unackalarmscount:0
            })

            setFilteredAlarms([]);
        }
    }, [data, props.checkfilterlist,selectedAlarm,config,tagdetails, filteredHistAlarms,selectedNodes,selectedTags,selectedDevices,snoozeRefreshTrigger]);

    // audio file 
    const alarmrecordscallback = (datareceived) => {
        //console.log("alarmrecordscallback-",datareceived)
        setData(datareceived.data);
    }

    const historicalalarmscallback = (datareceived) => {
        console.log("historicalalarmscallback-",datareceived)
        if (!datareceived || !datareceived?.data) {
            console.error("Invalid or null-like value for datareceived:", datareceived);
            return;
        }
        if(datareceived.status == 'success' || datareceived.status == 200){
            
            // var newAlarmsArray = [];
            // const newAlarmsFilter = new Set();
            
            //Raw received data
            var datareceivedarray = datareceived?.data?.data || [];
            
            //received data in form of 1 array
            const combinedArray = [];
            if(Array.isArray(datareceivedarray)){
                combinedArray.push(...datareceivedarray);
            }
            else{
                 if(datareceivedarray && Object.keys(datareceivedarray).length !=0){
                    for (const key in datareceivedarray) {
                        if (datareceivedarray.hasOwnProperty(key)) {
                            combinedArray.push(...datareceivedarray[key]);
                        }
                    }
                }
            }
            console.log("historicalalarmscallback combinedArray",combinedArray)   
        
            setFilteredHistAlarms(combinedArray)
            //updateFetchHistoricalAlertsCount(combinedArray?.length || 0);
        }else{
            setFilteredHistAlarms([]);
        }
    }

    const getSnoozeConfigcallback = (res) => {
        if(res.status == 'success'){
            //console.log("getSnoozeConfigcallback res",res.data.data[0])
            setprojectID(res.data.data[0].ProjectID)
            setID(res.data.data[0].id)
            setSnoozeDetails(res.data.data[0].snoozeDetails || []);
        }else{
            setSnoozeDetails([]);
        }   
    }

     // Check if an alert is snoozed
    const isAlertSnoozed = (alertID) => {
        const now = Math.trunc(Date.now()/1000);
        //console.log("isAlertSnoozed alertID",alertID,"snoozeDetails",snoozeDetails)
        return snoozeDetails.some((snooze) => {
            const snoozeEndTime = Number(snooze.snoozedAt)+ Number(snooze.snoozeDuration);
            //console.log("snoozeEndTime", snoozeEndTime, "now", now, "snooze.snoozedAt",snooze.snoozedAt,"snooze.snoozeDuration",snooze.snoozeDuration,"snooze.alertIDsCollection", snooze.alertIDsCollection, "alertID", alertID)
            return snooze.alertIDsCollection.includes(alertID) && now < snoozeEndTime;
        });
    };

    const postsnoozeAlarmConfigcallback = (res) => {
        //console.log("postsnoozeAlarmConfigcallback res",res)
        if(res.status != undefined && res.status != null && res.status == 200){
            setopenAlarmUpdatedandSaved(true);
            setSnoozeDetails(res.data.data[0].snoozeDetails || []);
        }else{
            setErrMessage('Could not save Snooze Configuration. Please try again.');
            setErrExists(true);
        }
    }

    const handleSaveSnooze = async () => {
        if (!selectedDuration) {
            setErrMessage('Please select a duration.');
            setErrExists(true);
            return;
        }

        const updatedSnoozeDetail = {
            snoozeID: Date.now(), // Keep the same snoozeID
            snoozeDuration: selectedDuration, // Matching duration
            snoozedAt: Math.trunc(Date.now() / 1000), // Updated snoozedAt
            alertIDsCollection: selectedAlerts, // Updated alert IDs
        };

        //console.log("updatedSnoozeDetail",updatedSnoozeDetail)

        // // Replace the matching object
        // let newsnoozeDetails = [];

        // for (let i = 0; i < snoozeDetails.length; i++) {
        //     if( snoozeDetails[i].snoozeDuration == updatedSnoozeDetail.snoozeDuration) {
        //         newsnoozeDetails[i] = updatedSnoozeDetail; // Update the matching snooze detail
        //     }else{
        //         newsnoozeDetails.push(snoozeDetails[i]); // Add the new snooze detail if no match found
        //     }
        // }
        //console.log("newsnoozeDetails---",newsnoozeDetails)
        // const snoozePayload = {
        //     ProjectID: projectID,
        //     id: ID,
        //     snoozeDetails: newsnoozeDetails
        // };
        //console.log("handleSaveSnooze snoozePayload",snoozePayload)
        
        try {
            //await axios.post("/api/snooze-config", snoozePayload);
            postsnoozeAlarmConfig(updatedSnoozeDetail, projectID, ID, userdetails.Userid, selectedprojectname,postsnoozeAlarmConfigcallback)
            setOpenSnoozeModal(false);
            setSelectedAlerts([]);
            setSelectedDuration("");
        } catch (error) {
            console.error("Error saving snooze configuration:", error);
        }
    };

    const getGroupTreecallback = (response) => {
        setGroups(response?.data?.data || []); // Set groups from response or use initial groups
    }

    useEffect(()=>{
            if(energyconsumersaver == false){
                //getTagDetailsInformationProjectwise(userdetails.Projectid,getTagDetailsInformationProjectwisecallback)
                if(userdetails && userdetails.Projectid && userdetails.Organizationid) {
                    if(userdetails.Projectid == 'All'){
                        getHistoricalAlarms(selectedprojectname, selecteddates_dashboard.startdates, selecteddates_dashboard.enddates, historicalalarmscallback)
                    }else{
                        getHistoricalAlarms(userdetails.Projectid, selecteddates_dashboard.startdates, selecteddates_dashboard.enddates, historicalalarmscallback)
                    }
                }   
            }
            if (usrPrmns.includes("PACF68")) {
                getSnoozeConfig(selectedprojectname,getSnoozeConfigcallback)
                getGroupTree(selectedprojectname, getGroupTreecallback)
            }
            if((livealarmarray != undefined) && (livealarmarray != null)){
                if(livealarmarray.length > 0){
                    // Simulate data loading
                    setTimeout(() => {
                        setLoading(false); // Set loading to false once data is loaded
                    }, 2000); 
                    
                    setData(livealarmarray)
                }else{
                    setLoading(false)
                    setData([]) 
                }
               
            }else{
                setLoading(false)
                setData([])
            }
        //}
    },[selecteddates_dashboard, fetchHistoricalAlerts,livealarmarray,selectedprojectname,energyconsumersaver])

    function handleAcknowledgeAlarm(alarmevent){
         //console.log("handleAcknowledgeAlarm(alarmevent)",alarmevent)
         if(alarmevent){
            var alarmEventAck = _.cloneDeep(alarmevent);
            if(alarmEventAck.hasOwnProperty('AcknowledgementStatus') && alarmEventAck.hasOwnProperty('AcknowledgementTime') && alarmEventAck.hasOwnProperty('UserID')){
                alarmEventAck.AcknowledgementStatus = true;
                alarmEventAck.AcknowledgementTime = new Date().getTime();
                alarmEventAck.UserID = username;
                //console.log("handleAcknowledgeAlarm=alarmEventAck",alarmEventAck)
                var obj = acknowledgealarmeventrecord(alarmEventAck, ackcallback);
            }
            
         }
          
    }

    function handleCommentAddition(comment,alert){
        console.log("handleCommentAddition comment,alert",comment,alert)
        addcommentalarmeventrecord(comment,alert,commentAdditioncallback)
    }
    
    const handleClose = () => {
        setAnchorEl(null); // Close the menu
    };

    const handleAcknowledge = (event) => {
        /*setAlarms((prevAlarms) =>
          prevAlarms.map((alarm) =>
            alarm.id === selectedAlarm.id ? { ...alarm, acknowledged: true } : alarm
          )
        );*/
        handleClose();
    };
  
    const handleAckClick = (alarm) => {
        setSelectedAlarm(alarm);
        setOpenDialog(true);
    }

    const handleAddCommentClick = (alert) => {
        if(alert){
            setCommentAddedOnAlarm(alert?.Comments)
            setSelectedCommentAlarm(alert)
            setOpennCommentDialog(true)
        }
        
    }

    const handleConfirmAck = () => {
        if(selectedAlarm) {
            handleAcknowledgeAlarm(selectedAlarm);
            setOpenDialog(false);
        }
    }

    const handleConfirmAddComment = (comment) => {
        if(selectedCommentAlarm && comment) {
            handleCommentAddition(comment, selectedCommentAlarm);
            setOpennCommentDialog(false);
        }
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }

    const handleCloseCommentDialog = () => {
        setOpennCommentDialog(false);
    }


    const ackcallback = (datareceived) => {
            var datacurrent = [];
            let inactiveAlertExists = false;

            console.log('ACKALERT | ackcallback start');
            console.log('ACKALERT | datareceived:', datareceived);
            console.log('ACKALERT | data exists:', !!data, '| data length:', Array.isArray(data) ? data.length : 'not-array');
            console.log('ACKALERT | is datareceived array:', Array.isArray(datareceived), '| datareceived length:', Array.isArray(datareceived) ? datareceived.length : 'n/a');

            if(data && data.length > 0){
                console.log('ACKALERT | entering main loop');
              
                for(var j=0;j<data.length;j++){
                    console.log('ACKALERT | loop index:', j, '| current data[j]:', data[j]);

                    // if(Array.isArray(datareceived) && datareceived.length == 0){
                    //     console.log('ACKALERT | branch: datareceived is empty array, keeping existing alert');
                    //     datacurrent.push(data[j]);
                    //     inactiveAlertExists = true;
                    //     console.log('ACKALERT | datacurrent length after push:', datacurrent.length, '| inactiveAlertExists:', inactiveAlertExists);
                    // }else{
                    if(Array.isArray(datareceived.data) && datareceived.data.length > 0){
                        console.log('ACKALERT | branch: datareceived is object/non-empty');
                        if(data[j] && data[j].hasOwnProperty('AlertID') && (datareceived.data[0].hasOwnProperty('AlertID'))){
                            console.log('ACKALERT | valid AlertID comparison | incoming AlertID:', datareceived.data[0].AlertID, '| current AlertID:', data[j]?.AlertID);
                            if(datareceived.data[0].AlertID != data[j]?.AlertID){
                                console.log('ACKALERT | AlertID mismatch, keeping current alert');
                                datacurrent.push(data[j]);
                                console.log('ACKALERT | datacurrent length after push:', datacurrent.length);
                            }else if(datareceived.data[0].AlertID == data[j]?.AlertID){
                                console.log('ACKALERT | AlertID match found');
                                if(data[j].State == 'inactive'){
                                    inactiveAlertExists = true; // Mark that an inactive alert exists
                                    console.log('ACKALERT | matched alert is inactive, inactiveAlertExists set to true');
                                }else{
                                    console.log('ACKALERT | matched alert is not inactive, state:', data[j].State);
                                }
                            }
                        }else{
                            console.log('ACKALERT | skipped item due to missing AlertID fields', {
                                hasCurrent: !!data[j],
                                currentHasAlertId: !!(data[j] && data[j].hasOwnProperty('AlertID')),
                                hasIncoming: !!datareceived,
                                incomingHasAlertId: !!(datareceived && datareceived.data[0] && datareceived.data[0].hasOwnProperty('AlertID')),
                            });
                        }
                    }
                    //}
                   
                }

                console.log('ACKALERT | loop complete | inactiveAlertExists:', inactiveAlertExists, '| datacurrent length:', datacurrent.length);
                
                if(inactiveAlertExists){
                    console.log('ACKALERT | final branch: inactive exists, updating data without prepending datareceived.data[0]');
                    console.log('ACKALERT | final datacurrent:', datacurrent);
                    setData((prevState)=>[...datacurrent ]);
                    dispatch(updatealarmarray(datacurrent));
                }else{
                    console.log('ACKALERT | final branch: inactive does not exist, prepending datareceived.data[0]');
                    console.log('ACKALERT | final payload:', [datareceived.data[0], ...datacurrent ]);
                    setData((prevState)=>[datareceived.data[0], ...datacurrent ]);
                    dispatch(updatealarmarray([datareceived.data[0], ...datacurrent ]));
                }
                
            } else {
                console.log('ACKALERT | skipped processing because data is empty or unavailable');
            }

            console.log('ACKALERT | ackcallback end');
    }
    
    const commentAdditioncallback = (datareceived) => {
        console.log("commentAdditioncallback datareceived-",datareceived)
        var datacurrent = [];
        if(data && data.length > 0){
            for(var j=0;j<data.length;j++){
                if(data[j] && data[j].hasOwnProperty('AlertID') && (datareceived.data[0] != undefined) && (datareceived.data[0] != null) && (datareceived.data[0]) && (datareceived.data[0].hasOwnProperty('AlertID'))){
                    console.log("datareceived.data[0].AlertID-commentAdditioncallback",datareceived.data[0].AlertID,"data[j]?.AlertID",data[j]?.AlertID)
                    if(datareceived.data[0].AlertID != data[j]?.AlertID){
                        datacurrent.push(data[j]);
                    }
                }
            }
        
            setData((prevState)=>[datareceived.data[0], ...datacurrent]);
        }
        
    }

    const audioRef = useRef(null); 

    useEffect(() => {
        // Create audio instance only once
        audioRef.current = new Audio('/sounds/red-alert_nuclear_buzzer.mp3');
        audioRef.current.loop = true; // Set audio to loop continuously

        return () => {
            // Cleanup function to stop and reset audio on component unmount
            audioRef.current.pause();
            audioRef.current.currentTime = 0; // Reset playback to start
        };
    }, []); // Empty dependency array ensures this runs only on mount and unmount


    const playAlarmSound = () => {
        //if (!audioRef.current) {
        //    audioRef.current = new Audio('/sounds/red-alert_nuclear_buzzer.mp3');
        //    audioRef.current.loop = true;  // Set audio to loop continuously
        //}
        audioRef.current.play().catch(err => console.log("Playing alarm sounds  error message", err));
    };

    const stopAlarmSound = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;  
        }
    };

    const checkForAudioAlert = (alarms, config) => {
        if (!Array.isArray(alarms) || alarms.length === 0) {
            console.warn("Alarms array is undefined or empty.");
            stopAlarmSound(); // Stop sound if no alarms are provided
            return;
        }
        
        var currentconfig = alarmcurrentaudiostate;
        const hasHighestPriorityAlarm = alarms.some(alarm => alarm.AlertClass == "100" && alarm.AcknowledgementStatus == false);
        const hasHighPriorityAlarm = alarms.some(alarm => alarm.AlertClass == "75" && alarm.AcknowledgementStatus == false);
        const hasMediumPriorityAlarm = alarms.some(alarm => alarm.AlertClass == "50" && alarm.AcknowledgementStatus == false);
        const hasLowPriorityAlarm = alarms.some(alarm => alarm.AlertClass == "25" && alarm.AcknowledgementStatus == false);

        
        if (hasHighestPriorityAlarm && currentconfig.enableAudioForHighest) {
            playAlarmSound(); 
        }
        else if (hasHighPriorityAlarm && currentconfig.enableAudioForHigh) {
            playAlarmSound(); 
        }
        else if (hasMediumPriorityAlarm && currentconfig.enableAudioForMedium) {
            playAlarmSound(); 
        }
        else if (hasLowPriorityAlarm && currentconfig.enableAudioForLow) {
            playAlarmSound(); 
        } else {
            stopAlarmSound(); 
        }
    };

    // function findAbsolutePathByKey(node, targetKey, path = []) {
    //     if (node.key === targetKey) {
    //         return [...path, {key:node.key,
    //             label:node.label, 
    //             id:node.label, 
    //             maindashboardlist: node.maindashboardlist,
    //             subdashboardlist: node.subdashboardlist}];  // Return the path when the target key is found
    //     }
    
    //     // Traverse children if they exist
    //     if (node.children) {
    //         for (let child of node.children) {
    //             const result = findAbsolutePathByKey(child, targetKey, [...path, {key:node.key,
    //                 label:node.label, 
    //                 id:node.label, 
    //                 maindashboardlist: node.maindashboardlist,
    //                 subdashboardlist: node.subdashboardlist}]);
    //             if (result) {
    //                 return result; // If the target key is found in the subtree, return the path
    //             }
    //         }
    //     }
    
    //     return null;  // If the key is not found in the current node or its children
    // }

     // Step 1: Find all dashboard_pro keys for the given tagid
    // function getDashboardKeys(dashboardtagsmapping, tagid) {
    //     return Object.keys(dashboardtagsmapping).filter(dashboardPro => {
    //         const tags = dashboardtagsmapping[dashboardPro].tags;
    //         if (Array.isArray(tags)) {
    //             return tags.includes(tagid);
    //         }
    //         return false; // If it's not an array, ignore it
    //     });
    // }

    // // Step 2: Traverse Plantview to find child keys with matching dashboard_pro
    // function findChildKeysWithDashboardPro(plantview, dashboardKeys) {
    //     const resultKeys = [];

    //     function traverse(node) {
    //         if (!node) return;

    //         // Check if any dashboard_pro in subdashboardlist matches
    //         if (node.subdashboardlist) {
    //             node.subdashboardlist.flat().forEach(subdashboard => {
    //                 if (dashboardKeys.includes(subdashboard.dashboard_pro)) {
    //                     resultKeys.push({key:node.key, 
    //                                     id:node.label, 
    //                                     maindashboardlist: node.maindashboardlist,
    //                                     subdashboardlist: node.subdashboardlist});
    //                 }
    //             });
    //         }

    //         // Traverse children
    //         if (node.children) {
    //             node.children.forEach(child => traverse(child));
    //         }
    //     }
    //     console.log("plantviewfbjfbvkvk",plantview)
    //     // Start traversal for each root node in Plantview
    //     if(Array.isArray(plantview["Plantview"])){
    //         plantview["Plantview"].forEach(root => traverse(root));
    //     }
        

    //     return resultKeys;
    // }
    
    // function handleGotToDashboard(alarmtagid){
    //     //var path = plantpathcollect(plantviewlist, alarmtagid)
    //     const dashboardKeys = getDashboardKeys(dashboardstagsmapping, alarmtagid);
    //     const matchingChildKeys = findChildKeysWithDashboardPro(plantviewlist, dashboardKeys);

    //     console.log('Matching Child Keys:', matchingChildKeys);
    //     console.log("plantviewlist IN OPERATE QSR-",plantviewlist)
    //     const absolutePath = plantviewlist["Plantview"]?.children.map(root => findAbsolutePathByKey(root, matchingChildKeys[0]?.key)).find(path => path !== null);
    //     console.log("absoluetpath",absolutePath)
    //     var maindashboardofkeytab = '';
    //     var subdashboardofkeytab = '';
    //     if(absolutePath != undefined){
    //         maindashboardofkeytab = absolutePath[absolutePath.length-1]?.maindashboardlist
    //         subdashboardofkeytab = absolutePath[absolutePath.length-1]?.subdashboardlist
    //     }
        
    //     console.log("maindashboardofkeytab",subdashboardofkeytab)
    //     console.log('Matching Dashboard Keys:', dashboardKeys);
    //     var maindashboardsubdashboardarray = [];
    //     var breadcrumbstreepatharray = [];
    //     for(var j=0;j<dashboardKeys.length;j++){
    //         var dashboardgroupid = dashboardstagsmapping[dashboardKeys[j]]?.groupid;
            
    //         for(var k=0;k<maindashboardofkeytab.length;k++){
    //             if(maindashboardofkeytab[k].groupid == dashboardgroupid){
    //                 console.log("maindashboardofkeytab[k].label on reaching here",maindashboardofkeytab[k].label)
    //                 maindashboardsubdashboardarray.push(maindashboardofkeytab[k].label)
    //             }
    //             break;
    //         }

    //         for(var k=0;k<subdashboardofkeytab.length;k++){
    //             var subdashboard = subdashboardofkeytab[k];
    //             for(var h=0;h<subdashboard.length;h++){
    //                 if(subdashboard[k].dashboard_pro==dashboardKeys[j]){
    //                     console.log("subdashboard[k].label on reaching here",subdashboard[k].label)
    //                     maindashboardsubdashboardarray.push(subdashboard[k].label)
    //                 }
    //                 break;
    //             }
    //         }

    //     }

    //     if(absolutePath != undefined){
    //         for(var j=0;j<absolutePath.length;j++){
    //             breadcrumbstreepatharray.push(absolutePath[j].label)
    //         }
    //     }
        

    //     var breadcrumbstreepatharray = [...breadcrumbstreepatharray];
    //     var breadcrumbstabpatharray = [];
    //     breadcrumbstabpatharray.push(maindashboardsubdashboardarray[0]);
    //     breadcrumbstabpatharray.push(maindashboardsubdashboardarray[1]);
    //     // breadcrumbsarray.push(maindashboardsubdashboardarray[0]);
    //     // breadcrumbsarray.push(maindashboardsubdashboardarray[1]);
    //     // console.log("maindashboardsubdashboardarray---",breadcrumbsarray)
    //     console.log("breadcrumbstreepatharray ibatiend",breadcrumbstreepatharray,"matchingChildKeys[0]",matchingChildKeys[0])
    //     var newpath = [];
    //     // for(var k=0;k<breadcrumbsarray.length;k++){
    //     //     newpath.push(
    //     //         <Typography
    //     //           key="Dashboards"
    //     //           className="crumbs"
    //     //           style={{ fontSize: "14px", fontWeight: 400 }}
    //     //         >
    //     //           {breadcrumbsarray[k]}
    //     //         </Typography>
    //     //       );
    //     // }

    //     //dispatch(updatealertbasedtreepath({setvalue:true, id: matchingChildKeys[0]?.key, breadcrumbpath: newpath, breadcrumbstreepatharray:breadcrumbstreepatharray}));
    //     //dispatch(updatetreepathselected(breadcrumbstreepatharray))
    //     dispatch(updatetabpath(breadcrumbstabpatharray))
    //     dispatch(updateselectedtreedashboard(matchingChildKeys[0]))
    //     dispatch(setPage('home'))
    // }
    
    function epochDifferenceToHHMMSS(epochDifference) {
        // Ensure epochDifference is a number
        if (typeof epochDifference !== 'number') {
          return "Invalid input: epochDifference must be a number";
        }
      
        // Calculate absolute value for handling negative differences
        const absoluteDifference = Math.abs(epochDifference/1000);
      
        // Calculate hours
        const hours = Math.floor(absoluteDifference / 3600);
      
        // Calculate minutes
        const minutes = Math.floor((absoluteDifference % 3600) / 60);
      
        // Calculate seconds
        const seconds = Math.floor(absoluteDifference % 60);
      
        // Format the output with leading zeros
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');
      
        // Add sign if difference is negative
        //const sign = epochDifference < 0 ? "-" : "";
      
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    const handleSort = (column) => {
        const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
        setSortColumn(column);
        setSortOrder(order);

        const sortedAlarms = [...filteredAlarms].sort((a, b) => {
            if (a[column] < b[column]) return order === "asc" ? -1 : 1;
            if (a[column] > b[column]) return order === "asc" ? 1 : -1;
            return 0;
        });
        setFilteredAlarms(sortedAlarms);
    };

    return (
      <>
          { /* console.log("in AlarmLeftPane module-props.checkfilterlist in AlarmEvents---------------...////////",props.checkfilterlist) */}
         {loading ? (
                <Box sx={{gap:'8px',boxSizing:"border-box",height:'100%',width:'100%',alignContent:"center"}} >
                    <img src={LK_Loading} alt="loading..." style={{height:"15%" ,width:"auto",alignSelf:"center"}} />
                </Box>
            ) : (
                <>
                    <Box sx={{width: '100%',border:"0px",padding:"0px"}}>
                        <div style={{ display: "block", height:"18%",width: '100%', paddingBottom: '0px' }}>
                            <div>
                                <table align='left' style={{ margin: 0, padding: '0', borderSpacing: 0, marginTop: '15px',marginLeft:'5px' }}>
                                    <tr>
                                        <td style={{ paddingRight: '20px' }}>
                                            <Typography style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)" }}>Total</Typography>
                                        </td>
                                        <td style={{ paddingRight: '40px' }}>
                                            <Typography style={{ fontSize: '18px', fontWeight: 400, color: "var(--PrimaryText)" }}>{countAlarms?.totalalarmscount ?? 0}</Typography>
                                        </td>
                                        {/*<td style={{ paddingRight: '20px' }}>
                                            <Chart
                                                options={options}
                                                series={series}
                                                type={'bar'}
                                                height="43px"
                                                width="300px"
                                            />
                                        </td>*/}
                                        <td>
                                        <div style={{display:"flex", flexDirection:"row",marginRight:"10px"}}>
                                                <div style={{display:"flex", flexDirection:"row",marginRight:"10px"}}>
                                                    <div style={{width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'var(--RedBaseColor)',marginTop:"5px"}}></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)",marginLeft:"5px",marginRight:"5px" }}>{"Highest"}</Typography></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)" }}>{series[0]?.data[0]}</Typography></div>
                                                </div>
                                                <div style={{display:"flex", flexDirection:"row",marginRight:"10px"}}>
                                                    <div style={{width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'var(--AmberBaseColor)',marginTop:"5px"}}></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)",marginLeft:"5px",marginRight:"5px" }}>{"High"}</Typography></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)" }}>{series[1]?.data[0]}</Typography></div>
                                                </div>
                                                <div style={{display:"flex", flexDirection:"row",marginRight:"10px"}}>
                                                    <div style={{width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'var(--YellowBaseColor)',marginTop:"5px"}}></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)",marginLeft:"5px",marginRight:"5px" }}>{"Medium"}</Typography></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)" }}>{series[2]?.data[0]}</Typography></div>
                                                </div>
                                                <div style={{display:"flex", flexDirection:"row",marginRight:"10px"}}>
                                                    <div style={{width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'var(--GreenBaseColor)',marginTop:"5px"}}></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)",marginLeft:"5px",marginRight:"5px" }}>{"Low"}</Typography></div>
                                                    <div><Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)" }}>{series[3]?.data[0]}</Typography></div>
                                                </div>
                                            </div>    
                                        </td>
                                        {/*<td>
                                            <FiberManualRecordIcon style={{ width: '15px', height: '15px', color: 'var(--pure-red)' }} />
                                        </td>
                                        <td style={{ paddingRight: '10px' }}>
                                            <Typography style={{ fontSize: '12px', fontWeight: 400, color: "var(--PrimaryText)" }}>Highest</Typography>
                                        </td>
                                        <td>
                                            <FiberManualRecordIcon style={{ width: '15px', height: '15px', color: 'var(--orange)' }} />
                                        </td>
                                        <td style={{ paddingRight: '10px' }}>
                                            <Typography style={{ fontSize: '12px', fontWeight: 400, color: "var(--PrimaryText)" }}>High</Typography>
                                        </td>
                                        <td>
                                            <FiberManualRecordIcon style={{ width: '15px', height: '15px', color: 'var(--zinc-yellow)' }} />
                                        </td>
                                        <td style={{ paddingRight: '10px' }}>
                                            <Typography style={{ fontSize: '12px', fontWeight: 400, color: "var(--PrimaryText)" }}>Medium</Typography>
                                        </td>
                                        <td>
                                            <FiberManualRecordIcon style={{ width: '15px', height: '15px', color: 'var(--pure-green)' }} />
                                        </td>
                                        <td style={{ paddingRight: '40px' }}>
                                            <Typography style={{ fontSize: '12px', fontWeight: 400, color: "var(--PrimaryText)" }}>Low</Typography>
                                        </td>
                                        */}
                                        <td style={{ paddingRight: '20px' }}>
                                            <Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)" }}>Unacknowledged Alarms</Typography>
                                        </td>
                                        <td>
                                            <Typography style={{ fontSize: '18px', fontWeight: 400, color: "var(--pure-red)" }}>{countAlarms?.unackalarmscount ?? 0}</Typography>
                                        </td>
                                        <td>
                                            
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div style={{flexGrow:3}}></div>
                            <div style={{display:'flex', justifyContent:'flex-end'}}>
                                                <div style={{flexGrow: 1}}></div>
                                                {/* <div style={{marginLeft:"700px"}}> */}
                                                {/*   <Button disabled={selectedAlerts.length === 0} sx={{ outline:'none !important',boxShadow:'none', height:'30px', width:'150px',fontSize: '12px',textTransform:'capitalize', marginTop:"20px", marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" onClick={() => setOpenSnoozeModal(true)}>Snooze Tags Alerts</Button>
                                                */}
                                                {/* </div> */}
                                                <div> 
                                                    <SwitchComponent checkedA={energyconsumersaver} energyconsumersaver={energyconsumersaver} setStateVarConsumerSaver={setEnergyconsumersaver} switchstate={switchstate}/>
                                                </div>
                                                <div>
                                                        <Button
                                                                    disabled={selectedAlerts.length === 0}
                                                                    sx={{
                                                                        outline: 'none !important',
                                                                        boxShadow: 'none',
                                                                        height: '30px',
                                                                        width: '150px',
                                                                        fontSize: '12px',
                                                                        textTransform: 'capitalize',
                                                                        marginTop: '20px',
                                                                        marginRight: '5px',
                                                                        backgroundColor: '#005C8E',
                                                                        borderRadius: '20px',
                                                                    }}
                                                                    variant="contained"
                                                                    onClick={() => setOpenSnoozeModal(true)}
                                                                >
                                                                    Snooze Alerts
                                                                </Button>
                                                </div>
                                            </div>
                            {/*<Typography style={{ fontSize: '14px', fontWeight: 400, color: "var(--PrimaryText)", marginTop: '10px' }}>Note: Alerts can be viewed at individual project level.</Typography>*/}
                        </div>
                        <TableContainer component={Paper} sx={{  height:"80%", width:"100%",paddingLeft:'0px',backgroundColor:'var(--SecondaryBackground)',paddingRight:'0px' }} elevation={0}>
                            <Table sx={{}} size="large" >
                                <TableHead>
                                <TableRow sx={{border:"0px"}}>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("AlertID")}><CustomTableHeading>Snooze Alerts</CustomTableHeading></TableCell> 
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("AlertClass")}><CustomTableHeading>Priority  {sortColumn === "AlertClass" && (sortOrder === "asc" ? <ArrowUpwardIcon sx={{marginTop:2}} fontSize="small" /> : <ArrowDownwardIcon sx={{marginTop:2}} fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("Timestamp")}><CustomTableHeading>Time {sortColumn === "Timestamp" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("TagID")}><CustomTableHeading>Tagname {sortColumn === "Tagname" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} ><CustomTableHeading>Value</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} ><CustomTableHeading>Message </CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("State")}><CustomTableHeading>Status {sortColumn === "State" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("AcknowledgementStatus")}><CustomTableHeading>Ack State {sortColumn === "AcknowledgementStatus" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("AcknowledgementTime")}><CustomTableHeading>Ack Time {sortColumn === "AcknowledgementTime" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("UserID")}><CustomTableHeading>User {sortColumn === "UserID" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("WentTime")}><CustomTableHeading>Went Time {sortColumn === "WentTime" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}} onClick={() => handleSort("Comments")}><CustomTableHeading>Comments {sortColumn === "Comments" && (sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}</CustomTableHeading></TableCell> 
                                    {/* <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)", cursor: "pointer"}}><CustomTableHeading>Status</CustomTableHeading></TableCell> */}
                                    {/* <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Go to Dashboard'}/></TableCell> */}
                                    {/* <TableCell align="left" sx={{ fontSize:"14px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Cummulative Time'}/></TableCell> */}
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {(Array.isArray(filteredAlarms) && filteredAlarms.length > 0 && energyconsumersaver == true) 
                                ? 
                                filteredAlarms.map((alarm, index) => {

                                    const snoozed = isAlertSnoozed(alarm.AlertID);
                                    if (!alarm || Object.keys(alarm).length === 0) {
                                        return null; // Skip rendering if alarm is undefined or empty
                                    }
                                    // var acknowledgement_time_date = new Date(alarm.AcknowledgementTime);
                                    // var time_date = new Date(alarm.Timestamp);
                                    // // console.log()
                                    // var acknowledgement_time_date_isostring = acknowledgement_time_date.toISOString();
                                    // var time_date_isostring = time_date.toISOString();

                                    //// console.log("vardate-----",vardate)
                                    // console.log("alarm.AcknowledgementTime",alarm.AcknowledgementTime)
                                    //console.log("new Date(alarm.Timestamp)-filteredAlarms",filteredAlarms)
                    
                                    const timedate = new Date(Number(alarm.Timestamp));

                                    var ackdate;
                                    var ackoveralldate;
                                    var wenttime;
                                    var wenttime_ISOString;
                                    var wenttimeoveralldate;
                                    if(alarm.WentTime == ''){
                                        wenttime = '';
                                        wenttimeoveralldate = '';
                                    }else{
                                        wenttime = new Date(Number(alarm.WentTime));
                                        var wenttimeyear = wenttime.getFullYear();
                                        var wenttimeyear = wenttimeyear + "";
                                        if(wenttimeyear.length < 4){
                                            while(wenttimeyear.length < 4){
                                                wenttimeyear = "0"+wenttimeyear
                                            }
                                        }
                                        var wenttimemonth = wenttime.getMonth()+1;
                                        var wenttimemonth = wenttimemonth + "";
                                        if(wenttimemonth.length < 2){
                                            while(wenttimemonth.length < 2){
                                                wenttimemonth = "0"+wenttimemonth
                                            }
                                        }
                                        var wenttimedaydate = wenttime.getDate();
                                        var wenttimedaydate = wenttimedaydate + "";
                                        if(wenttimedaydate.length < 2){
                                            while(wenttimedaydate.length < 2){
                                                wenttimedaydate = "0"+wenttimedaydate
                                            }
                                        }
                                        var wenttimehour =  wenttime.getHours();
                                        var wenttimehour = wenttimehour + "";
                                        if(wenttimehour.length < 2){
                                            while(wenttimehour.length < 2){
                                                wenttimehour = "0"+wenttimehour
                                            }
                                        }
                                        var wenttimeminute =  wenttime.getMinutes();
                                        var wenttimeminute = wenttimeminute + "";
                                        if(wenttimeminute.length < 2){
                                            while(wenttimeminute.length < 2){
                                                wenttimeminute = "0"+wenttimeminute
                                            }
                                        }
                                        var wenttimesec =  wenttime.getSeconds();
                                        var wenttimesec = wenttimesec + "";
                                        if(wenttimesec.length < 2){
                                            while(wenttimesec.length < 2){
                                                wenttimesec = "0"+wenttimesec
                                            }
                                        }
                                        var wenttimemsec =  wenttime.getMilliseconds();
                                        var  wenttimemsec =  wenttimemsec + "";
                                        if(wenttimemsec.length < 3){
                                            while(wenttimemsec.length < 3){
                                                wenttimemsec = "0"+wenttimemsec
                                            }
                                        }
                                        wenttimeoveralldate = wenttimeyear+"-"+wenttimemonth+"-"+wenttimedaydate+" "+wenttimehour+":"+wenttimeminute+":"+wenttimesec+"."+wenttimemsec;
                                        //wenttime_ISOString = wenttime.toISOString();
                                    }

                                    if(alarm.AcknowledgementTime == ''){
                                        ackdate = '';
                                        ackoveralldate = ''
                                    }else{
                                        ackdate = new Date(Number(alarm.AcknowledgementTime));
                                        var ackyear = ackdate.getFullYear();
                                        var ackyear = ackyear + "";
                                        if(ackyear.length < 4){
                                            while(ackyear.length < 4){
                                                ackyear = "0"+ackyear
                                            }
                                        }
                                        var ackmonth = ackdate.getMonth()+1;
                                        var ackmonth = ackmonth + "";
                                        if(ackmonth.length < 2){
                                            while(ackmonth.length < 2){
                                                ackmonth = "0"+ackmonth
                                            }
                                        }
                                        var ackdaydate = ackdate.getDate();
                                        var ackdaydate = ackdaydate + "";
                                        if(ackdaydate.length < 2){
                                            while(ackdaydate.length < 2){
                                                ackdaydate = "0"+ackdaydate
                                            }
                                        }
                                        var ackhour =  ackdate.getHours();
                                        var ackhour = ackhour + "";
                                        if(ackhour.length < 2){
                                            while(ackhour.length < 2){
                                                ackhour = "0"+ackhour
                                            }
                                        }
                                        var ackminute =  ackdate.getMinutes();
                                        var ackminute = ackminute + "";
                                        if(ackminute.length < 2){
                                            while(ackminute.length < 2){
                                                ackminute = "0"+ackminute
                                            }
                                        }
                                        var acksec =  ackdate.getSeconds();
                                        var acksec = acksec + "";
                                        if(acksec.length < 2){
                                            while(acksec.length < 2){
                                                acksec = "0"+acksec
                                            }
                                        }

                                        var ackmsec =  ackdate.getMilliseconds();
                                        var ackmsec = ackmsec + "";
                                        if(ackmsec.length < 3){
                                            while(ackmsec.length < 3){
                                                ackmsec = "0"+ackmsec
                                            }
                                        }
                                        ackoveralldate = ackyear+"-"+ackmonth+"-"+ackdaydate+" "+ackhour+":"+ackminute+":"+acksec+"."+ackmsec;
                                        // const ackdate_ISOString = ackdate.toISOString();
                                    }
                                    
                                    // console.log("----typeof alarm.state--------",typeof alarm.state)
                                    // console.log("---typeof alarm.AcknowledgementStatus----",typeof alarm.AcknowledgementStatus)

                                    var timedateyear = timedate.getFullYear();
                                    var timedateyear = timedateyear + "";
                                    if(timedateyear.length < 4){
                                        while(timedateyear.length < 4){
                                            timedateyear = "0"+timedateyear
                                        }
                                    }

                                    var timedatemonth = timedate.getMonth()+1;
                                    var timedatemonth = timedatemonth + "";
                                    if(timedatemonth.length < 2){
                                        while(timedatemonth.length < 2){
                                            timedatemonth = "0"+timedatemonth
                                        }
                                    }

                                    var timedatedaydate = timedate.getDate();
                                    var timedatedaydate = timedatedaydate + "";
                                    if(timedatedaydate.length < 2){
                                        while(timedatedaydate.length < 2){
                                            timedatedaydate = "0"+timedatedaydate
                                        }
                                    }

                                    var timedatehour =  timedate.getHours();
                                    var timedatehour = timedatehour + "";
                                    if(timedatehour.length < 2){
                                        while(timedatehour.length < 2){
                                            timedatehour = "0"+timedatehour
                                        }
                                    }

                                    var timedateminute =  timedate.getMinutes();
                                    var timedateminute = timedateminute + "";
                                    if(timedateminute.length < 2){
                                        while(timedateminute.length < 2){
                                            timedateminute = "0"+timedateminute
                                        }
                                    }
                                    
                                    var timedatesec =  timedate.getSeconds();
                                    var timedatesec = timedatesec + "";
                                    if(timedatesec.length < 2){
                                        while(timedatesec.length < 2){
                                            timedatesec = "0"+timedatesec
                                        }
                                    }

                                    var timedatemsec =  timedate.getMilliseconds();
                                    var timedatemsec = timedatemsec + "";
                                    if(timedatemsec.length < 3){
                                        while(timedatemsec.length < 3){
                                            timedatemsec = "0"+timedatemsec
                                        }
                                    }

                                    var timedateoveralldate = timedateyear+"-"+timedatemonth+"-"+timedatedaydate+" "+timedatehour+":"+timedateminute+":"+timedatesec+"."+timedatemsec;

                                    // const timedate_ISOString = timedate.toISOString();
                                    // console.log("ackdate_ISOString",ackdate_ISOString)
                                    // console.log("timedate_ISOString",timedate_ISOString)

                                    return(
                                            alarm &&
                                                alarm.hasOwnProperty('TagID') &&
                                                alarm.hasOwnProperty('AcknowledgementStatus') &&
                                                alarm.hasOwnProperty('State') &&
                                                alarm.hasOwnProperty('UserID') &&
                                                alarm.hasOwnProperty('Comments') 
                                                 ? (   <TableRow
                                                key={alarm.AlertID}
                                                sx={{'&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" }, backgroundColor: snoozed ? "#f0f0f0" :'var(--SecondaryBackground)',pointerEvents: snoozed ? "none" : "auto", opacity: snoozed ? 0.5 : 1,}}
                                            >
                                                
                                                {/* console.log("snoozedtaglist[alarm.TagID]?.Shelve_End_Time",snoozedtaglist[alarm.TagID]?.Shelve_End_Time,"Date.now()",Date.now(),"snoozedtaglist",snoozedtaglist) */}
                                                {/*<TableCell component="th" scope="row" sx={{  width:"13%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Checkbox checkedIcon={<CheckBoxOutlinedIcon />}  style={{color:'var(--SecondaryText)', color:"008CD7"}}
                                                                            checked={selectedAlerts.includes(alarm.AlertID)}
                                                                            sx={{
                                                                                padding: 0,
                                                                                margin: 0,
                                                                                color: 'var(--HighlightedText_Stroke)',
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: '20px',
                                                                                    color: 'var(--HighlightedText_Stroke)'
                                                                                }
                                                                            }}
                                                                            onChange={() => handleAlertSelection(alarm.AlertID)}
                                                                        />
                                                </TableCell>
                                                */}
                                                <TableCell>
                                                    <Checkbox
                                                        checked={selectedAlerts.includes(alarm.AlertID)}
                                                        onChange={() => handleAlertSelection(alarm.AlertID)}
                                                        sx={{
                                                            color: 'var(--HighlightedText_Stroke)',
                                                            '& .MuiSvgIcon-root': { fontSize: '20px' },
                                                        }}
                                                    />
                                                </TableCell>
                                                {(alarm.AlertClass == "100") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false))?<BlinkingSevereIcon /> :<SevereIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"Highest"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                {(alarm.AlertClass == "75") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false) )?<BlinkingAlarmIcon /> :<AlarmIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"High"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                {(alarm.AlertClass == "50") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false) )?<BlinkingWarningIcon /> :<WarningIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"Medium"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                {(alarm.AlertClass == "25") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false) )?<BlinkingInformationIcon /> :<InformationIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"Low"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                <TableCell component="th" scope="row" sx={{  width:"13%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)' }}>{timedateoveralldate}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"10%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}>
                                                        <div style={{display:"flex", flexDirection:"row"}}>
                                                            <div>
                                                                <Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(devicedetails && tagdetails && tagdetails.hasOwnProperty(alarm.TagID) && devicedetails.hasOwnProperty(tagdetails[alarm.TagID]?.DeviceID) &&devicedetails[tagdetails[alarm.TagID]?.DeviceID]?.Name != undefined) ? devicedetails[tagdetails[alarm.TagID]?.DeviceID]?.Name : "Device-Name"}</Typography>
                                                            </div>
                                                            <div>
                                                                <Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{":"}</Typography>
                                                            </div>
                                                            <div>
                                                                <Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(tagdetails && tagdetails.hasOwnProperty(alarm.TagID) && tagdetails[alarm.TagID]?.TagID != undefined) ? tagdetails[alarm.TagID]?.Alias :"Tag-Name"}</Typography>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{alarm.TagValue}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.State == 'inactive') ? (((alarm.Normal_Message != undefined ) && (alarm.Normal_Message != null)) ? alarm.Normal_Message : ''):(((alarm.Abnormal_Message != undefined )   &&    (alarm.Abnormal_Message != null)) ? alarm.Abnormal_Message : "")}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{alarm.State}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.AcknowledgementStatus == false) ? <CustomActionButton disabled={!usrPrmns.includes("PAAC69")} onClick={()=>handleAckClick(alarm)} buttonText={'Acknowledge'} /> : "Acknowledged"}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{ackoveralldate}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"5%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{alarm.UserID}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography  className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{wenttimeoveralldate}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.Comments=='')?<CustomActionButton disabled={!usrPrmns.includes("PACM70")} onClick={()=>handleAddCommentClick(alarm)} buttonText={'Add Comment'} />:alarm.Comments}</Typography></TableCell>
                                                {/* <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }} onClick={()=>handleGotToDashboard(alarm.TagID)}>{'Go to Dashboard'}</Typography></TableCell> */}
                                                {/* <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.State == 'inactive')?epochDifferenceToHHMMSS(Number(alarm.CummulativeTime)):''}</Typography></TableCell> */}
                                                {/*<TableCell>
                                                    {snoozed ? (
                                                        <Typography color="textSecondary">Snoozed</Typography>
                                                    ) : (
                                                        "Active"
                                                    )}
                                                </TableCell> */}
                                            </TableRow>):<></>
                                        )
                                })
                                :
                                <></>}

                                {(Array.isArray(filteredHistAlarms) && filteredHistAlarms.length > 0 && energyconsumersaver == false) 
                                ? 
                                filteredHistAlarms.map((alarm, index) => {

                                    const snoozed = isAlertSnoozed(alarm.AlertID);
                                    if (!alarm || Object.keys(alarm).length === 0) {
                                        return null; // Skip rendering if alarm is undefined or empty
                                    }
                                    // var acknowledgement_time_date = new Date(alarm.AcknowledgementTime);
                                    // var time_date = new Date(alarm.Timestamp);
                                    // // console.log()
                                    // var acknowledgement_time_date_isostring = acknowledgement_time_date.toISOString();
                                    // var time_date_isostring = time_date.toISOString();

                                    //// console.log("vardate-----",vardate)
                                    // console.log("alarm.AcknowledgementTime",alarm.AcknowledgementTime)
                                    //console.log("new Date(alarm.Timestamp)-filteredAlarms",filteredAlarms)
                    
                                    const timedate = new Date(Number(alarm.Timestamp));

                                    var ackdate;
                                    var ackoveralldate;
                                    var wenttime;
                                    var wenttime_ISOString;
                                    var wenttimeoveralldate;
                                    if(alarm.WentTime == ''){
                                        wenttime = '';
                                        wenttimeoveralldate = '';
                                    }else{
                                        wenttime = new Date(Number(alarm.WentTime));
                                        var wenttimeyear = wenttime.getFullYear();
                                        var wenttimeyear = wenttimeyear + "";
                                        if(wenttimeyear.length < 4){
                                            while(wenttimeyear.length < 4){
                                                wenttimeyear = "0"+wenttimeyear
                                            }
                                        }
                                        var wenttimemonth = wenttime.getMonth()+1;
                                        var wenttimemonth = wenttimemonth + "";
                                        if(wenttimemonth.length < 2){
                                            while(wenttimemonth.length < 2){
                                                wenttimemonth = "0"+wenttimemonth
                                            }
                                        }
                                        var wenttimedaydate = wenttime.getDate();
                                        var wenttimedaydate = wenttimedaydate + "";
                                        if(wenttimedaydate.length < 2){
                                            while(wenttimedaydate.length < 2){
                                                wenttimedaydate = "0"+wenttimedaydate
                                            }
                                        }
                                        var wenttimehour =  wenttime.getHours();
                                        var wenttimehour = wenttimehour + "";
                                        if(wenttimehour.length < 2){
                                            while(wenttimehour.length < 2){
                                                wenttimehour = "0"+wenttimehour
                                            }
                                        }
                                        var wenttimeminute =  wenttime.getMinutes();
                                        var wenttimeminute = wenttimeminute + "";
                                        if(wenttimeminute.length < 2){
                                            while(wenttimeminute.length < 2){
                                                wenttimeminute = "0"+wenttimeminute
                                            }
                                        }
                                        var wenttimesec =  wenttime.getSeconds();
                                        var wenttimesec = wenttimesec + "";
                                        if(wenttimesec.length < 2){
                                            while(wenttimesec.length < 2){
                                                wenttimesec = "0"+wenttimesec
                                            }
                                        }
                                        var wenttimemsec =  wenttime.getMilliseconds();
                                        var  wenttimemsec =  wenttimemsec + "";
                                        if(wenttimemsec.length < 3){
                                            while(wenttimemsec.length < 3){
                                                wenttimemsec = "0"+wenttimemsec
                                            }
                                        }
                                        wenttimeoveralldate = wenttimeyear+"-"+wenttimemonth+"-"+wenttimedaydate+" "+wenttimehour+":"+wenttimeminute+":"+wenttimesec+"."+wenttimemsec;
                                        //wenttime_ISOString = wenttime.toISOString();
                                    }

                                    if(alarm.AcknowledgementTime == ''){
                                        ackdate = '';
                                        ackoveralldate = ''
                                    }else{
                                        ackdate = new Date(Number(alarm.AcknowledgementTime));
                                        var ackyear = ackdate.getFullYear();
                                        var ackyear = ackyear + "";
                                        if(ackyear.length < 4){
                                            while(ackyear.length < 4){
                                                ackyear = "0"+ackyear
                                            }
                                        }
                                        var ackmonth = ackdate.getMonth()+1;
                                        var ackmonth = ackmonth + "";
                                        if(ackmonth.length < 2){
                                            while(ackmonth.length < 2){
                                                ackmonth = "0"+ackmonth
                                            }
                                        }
                                        var ackdaydate = ackdate.getDate();
                                        var ackdaydate = ackdaydate + "";
                                        if(ackdaydate.length < 2){
                                            while(ackdaydate.length < 2){
                                                ackdaydate = "0"+ackdaydate
                                            }
                                        }
                                        var ackhour =  ackdate.getHours();
                                        var ackhour = ackhour + "";
                                        if(ackhour.length < 2){
                                            while(ackhour.length < 2){
                                                ackhour = "0"+ackhour
                                            }
                                        }
                                        var ackminute =  ackdate.getMinutes();
                                        var ackminute = ackminute + "";
                                        if(ackminute.length < 2){
                                            while(ackminute.length < 2){
                                                ackminute = "0"+ackminute
                                            }
                                        }
                                        var acksec =  ackdate.getSeconds();
                                        var acksec = acksec + "";
                                        if(acksec.length < 2){
                                            while(acksec.length < 2){
                                                acksec = "0"+acksec
                                            }
                                        }

                                        var ackmsec =  ackdate.getMilliseconds();
                                        var ackmsec = ackmsec + "";
                                        if(ackmsec.length < 3){
                                            while(ackmsec.length < 3){
                                                ackmsec = "0"+ackmsec
                                            }
                                        }
                                        ackoveralldate = ackyear+"-"+ackmonth+"-"+ackdaydate+" "+ackhour+":"+ackminute+":"+acksec+"."+ackmsec;
                                        // const ackdate_ISOString = ackdate.toISOString();
                                    }
                                    
                                    // console.log("----typeof alarm.state--------",typeof alarm.state)
                                    // console.log("---typeof alarm.AcknowledgementStatus----",typeof alarm.AcknowledgementStatus)

                                    var timedateyear = timedate.getFullYear();
                                    var timedateyear = timedateyear + "";
                                    if(timedateyear.length < 4){
                                        while(timedateyear.length < 4){
                                            timedateyear = "0"+timedateyear
                                        }
                                    }

                                    var timedatemonth = timedate.getMonth()+1;
                                    var timedatemonth = timedatemonth + "";
                                    if(timedatemonth.length < 2){
                                        while(timedatemonth.length < 2){
                                            timedatemonth = "0"+timedatemonth
                                        }
                                    }

                                    var timedatedaydate = timedate.getDate();
                                    var timedatedaydate = timedatedaydate + "";
                                    if(timedatedaydate.length < 2){
                                        while(timedatedaydate.length < 2){
                                            timedatedaydate = "0"+timedatedaydate
                                        }
                                    }

                                    var timedatehour =  timedate.getHours();
                                    var timedatehour = timedatehour + "";
                                    if(timedatehour.length < 2){
                                        while(timedatehour.length < 2){
                                            timedatehour = "0"+timedatehour
                                        }
                                    }

                                    var timedateminute =  timedate.getMinutes();
                                    var timedateminute = timedateminute + "";
                                    if(timedateminute.length < 2){
                                        while(timedateminute.length < 2){
                                            timedateminute = "0"+timedateminute
                                        }
                                    }
                                    
                                    var timedatesec =  timedate.getSeconds();
                                    var timedatesec = timedatesec + "";
                                    if(timedatesec.length < 2){
                                        while(timedatesec.length < 2){
                                            timedatesec = "0"+timedatesec
                                        }
                                    }

                                    var timedatemsec =  timedate.getMilliseconds();
                                    var timedatemsec = timedatemsec + "";
                                    if(timedatemsec.length < 3){
                                        while(timedatemsec.length < 3){
                                            timedatemsec = "0"+timedatemsec
                                        }
                                    }

                                    var timedateoveralldate = timedateyear+"-"+timedatemonth+"-"+timedatedaydate+" "+timedatehour+":"+timedateminute+":"+timedatesec+"."+timedatemsec;

                                    // const timedate_ISOString = timedate.toISOString();
                                    // console.log("ackdate_ISOString",ackdate_ISOString)
                                    // console.log("timedate_ISOString",timedate_ISOString)

                                    return(
                                            alarm &&
                                                alarm.hasOwnProperty('TagID') &&
                                                alarm.hasOwnProperty('AcknowledgementStatus') &&
                                                alarm.hasOwnProperty('State') &&
                                                alarm.hasOwnProperty('UserID') &&
                                                alarm.hasOwnProperty('Comments') 
                                                 ? (   <TableRow
                                                key={alarm.AlertID}
                                                sx={{'&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" }, backgroundColor: snoozed ? "#f0f0f0" :'var(--SecondaryBackground)',pointerEvents: snoozed ? "none" : "auto", opacity: snoozed ? 0.5 : 1,}}
                                            >
                                                {/* console.log("snoozedtaglist[alarm.TagID]?.Shelve_End_Time",snoozedtaglist[alarm.TagID]?.Shelve_End_Time,"Date.now()",Date.now(),"snoozedtaglist",snoozedtaglist) */}
                                                {/*<TableCell component="th" scope="row" sx={{  width:"13%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Checkbox checkedIcon={<CheckBoxOutlinedIcon />}  style={{color:'var(--SecondaryText)', color:"008CD7"}}
                                                                            checked={selectedAlerts.includes(alarm.AlertID)}
                                                                            sx={{
                                                                                padding: 0,
                                                                                margin: 0,
                                                                                color: 'var(--HighlightedText_Stroke)',
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: '20px',
                                                                                    color: 'var(--HighlightedText_Stroke)'
                                                                                }
                                                                            }}
                                                                            onChange={() => handleAlertSelection(alarm.AlertID)}
                                                                        />
                                                </TableCell>
                                                */}
                                                <TableCell>
                                                    <Checkbox
                                                        checked={selectedAlerts.includes(alarm.AlertID)}
                                                        onChange={() => handleAlertSelection(alarm.AlertID)}
                                                        sx={{
                                                            color: 'var(--HighlightedText_Stroke)',
                                                            '& .MuiSvgIcon-root': { fontSize: '20px' },
                                                        }}
                                                    />
                                                </TableCell>
                                                {(alarm.AlertClass == "100") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false))?<BlinkingSevereIcon /> :<SevereIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"Highest"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                {(alarm.AlertClass == "75") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false) )?<BlinkingAlarmIcon /> :<AlarmIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"High"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                {(alarm.AlertClass == "50") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false) )?<BlinkingWarningIcon /> :<WarningIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"Medium"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                {(alarm.AlertClass == "25") && <TableCell component="th" scope="row" sx={{ width:"10%",paddingTop:"10px",paddingBottom:"10px", fontSize:"14px",fontWeight:400}}>
                                                    <div style={{ display:"flex", flexDirection:"row", alignItems:"center"}}>
                                                        {((alarm.AcknowledgementStatus === false) )?<BlinkingInformationIcon /> :<InformationIcon />}
                                                        <Typography className='emission-config-metric' style={{ marginLeft:"5px",fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{"Low"}</Typography>
                                                    </div>
                                                </TableCell>}
                                                <TableCell component="th" scope="row" sx={{  width:"13%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)' }}>{timedateoveralldate}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"10%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}>
                                                        <div style={{display:"flex", flexDirection:"row"}}>
                                                            <div>
                                                                <Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(devicedetails && tagdetails && tagdetails.hasOwnProperty(alarm.TagID) && devicedetails.hasOwnProperty(tagdetails[alarm.TagID]?.DeviceID) &&devicedetails[tagdetails[alarm.TagID]?.DeviceID]?.Name != undefined) ? devicedetails[tagdetails[alarm.TagID]?.DeviceID]?.Name : "Device-Name"}</Typography>
                                                            </div>
                                                            <div>
                                                                <Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{":"}</Typography>
                                                            </div>
                                                            <div>
                                                                <Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(tagdetails && tagdetails.hasOwnProperty(alarm.TagID) && tagdetails[alarm.TagID]?.TagID != undefined) ? tagdetails[alarm.TagID]?.Alias :"Tag-Name"}</Typography>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{alarm.TagValue}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.State == 'inactive') ? (((alarm.Normal_Message != undefined ) && (alarm.Normal_Message != null)) ? alarm.Normal_Message : ''):(((alarm.Abnormal_Message != undefined )   &&    (alarm.Abnormal_Message != null)) ? alarm.Abnormal_Message : "")}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{alarm.State}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"9%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.AcknowledgementStatus == false) ? <CustomActionButton disabled={!usrPrmns.includes("PAAC69")} onClick={()=>handleAckClick(alarm)} buttonText={'Acknowledge'} /> : "Acknowledged"}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{ackoveralldate}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"5%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{alarm.UserID}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography  className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{wenttimeoveralldate}</Typography></TableCell>
                                                <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.Comments=='')?<CustomActionButton disabled={!usrPrmns.includes("PACM70")} onClick={()=>handleAddCommentClick(alarm)} buttonText={'Add Comment'} />:alarm.Comments}</Typography></TableCell>
                                                {/* <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }} onClick={()=>handleGotToDashboard(alarm.TagID)}>{'Go to Dashboard'}</Typography></TableCell> */}
                                                {/* <TableCell component="th" scope="row" sx={{  width:"15%",paddingTop:"10px",paddingBottom:"10px",fontSize:"14px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)'}}><Typography className='emission-config-metric' style={{ fontSize: '12px', fontWeight: 400, color: 'var(--SecondaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(alarm.State == 'inactive')?epochDifferenceToHHMMSS(Number(alarm.CummulativeTime)):''}</Typography></TableCell> */}
                                                {/*<TableCell>
                                                    {snoozed ? (
                                                        <Typography color="textSecondary">Snoozed</Typography>
                                                    ) : (
                                                        "Active"
                                                    )}
                                                </TableCell> */}
                                            </TableRow>):<></>
                                        )
                                })
                                :
                                <></>}
                                
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                        <MenuItem onClick={handleAcknowledge}>Acknowledge</MenuItem>
                        </Menu>

                    </Box>
                    {/* Confirmation Dialog */}
                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                    >
                        <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Confirm Acknowledgement</DialogTitle>
                            <DialogContent >
                                <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                    Are you sure you want to acknowledge this alarm?
                                </DialogContentText>
                            </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}> 
                            <Button onClick={handleConfirmAck} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                Yes
                            </Button>
                            <CustomCancelButton width={"125px"} onClick={handleCloseDialog} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={openSnoozeModal} onClose={() => setOpenSnoozeModal(false)}
                         BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Snooze Alerts</DialogTitle>
                        <DialogContent>
                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF",justifyContent:'center'}}>
                                <Typography>Select a snooze duration:</Typography>
                                <FormControl variant="standard" sx={{ marginTop:"0px", minWidth: 50,width:"200px", }}>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        IconComponent={KeyboardArrowDownIcon}
                                        sx={{
                                            "&:before": {
                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                            },
                                            "&:hover:not(.Mui-disabled):before": {
                                                borderBottom: '2px solid #008CD7',
                                            },
                                            "&:after": {
                                                borderBottom: '2px solid #008CD7',
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: '200px',
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: '700 !important',
                                            color: 'var(--PrimaryText)',
                                            '& .MuiInputBase-input': {
                                                paddingLeft: 0
                                            },
                                            '& .MuiInputBase-input:focus': {
                                                color: 'var(--HighlightedText_Stroke)',
                                                borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                backgroundColor: 'transparent',
                                                fontWeight: '700 !important',
                                                '& .MuiSvgIcon-root': {
                                                    color: 'var(--HighlightedText_Stroke) !important'
                                                },
                                            },
                                            '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                color: 'var(--HighlightedText_Stroke)',       //not working
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: 'var(--PrimaryText)'
                                            },
                                            '& .MuiNativeSelect-select': {
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                            },
                                            '& .MuiNativeSelect-select option': {
                                                backgroundColor: 'var(--dropdown-bg) !important',
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color: 'var(--PrimaryText) !important',
                                                borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                            },
                                            '& .MuiNativeSelect-select option:checked': {
                                                backgroundColor: 'var(--dropdown-bg) !important',
                                                color: 'var(--White) !important',
                                                fontWeight: '700 !important',
                                                borderColor: '2px solid var(--HighlightedText_Stroke)'
                                            },
                                            '& .MuiInputBase-input option:hover': {
                                                backgroundColor: '#005D8F !important',
                                            },
                                        }}
                                        MenuProps={{
                                            PaperProps:{
                                                sx:{
                                                    width:"200px",
                                                    bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                    borderBottom:'2px solid #008CD7',
                                                    borderRadius:0,
                                                    boxShadow:'none',
                                                    maxHeight:'250px',
                                                    overflow:'auto',
                                                    color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                }
                                            },               
                                        }}
                                        value={selectedDuration}
                                        onChange={(e) => setSelectedDuration(e.target.value)}
                                        fullWidth
                                    >
                                        <MenuItem sx={{paddingLeft:1}} value="" disabled>
                                            Select Duration
                                        </MenuItem>
                                        {predefinedDurations.map((duration) => (
                                            <MenuItem sx={{paddingLeft:1}} key={duration.value} value={duration.value}>
                                                {duration.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions  sx={{justifyContent:'center'}}>
                            <CustomButton onClick={handleSaveSnooze} buttonText={'Save'} />
                            <CustomCancelButton onClick={() => setOpenSnoozeModal(false)} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>

                    {<Dialog open={openGrouping} onClose={() => setGrouping(false)}
                         BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{'Sort By Group'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Tree Structure Component</Typography>
                                <div style={{width:"50%", display:"flex", flexDirection:"row"}} gap="30px">
                                    <FormControl variant="standard" sx={{ marginTop:"0px",marginLeft:"16px"}} fullWidth>
                                        <InputLabel style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C', fontSize: 18, fontWeight: 400}}>Group Name</InputLabel>
                                        <Select  labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    sx={{
                                                        "&:before": {
                                                            borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                        },
                                                        "&:hover:not(.Mui-disabled):before": {
                                                            borderBottom: '2px solid #008CD7',
                                                        },
                                                        "&:after": {
                                                            borderBottom: '2px solid #008CD7',
                                                        },
                                                        margin: 0,
                                                        padding: 0,
                                                        width: "260px",
                                                        fontSize: "18px",
                                                        fontFamily: "Roboto",
                                                        fontWeight: '700 !important',
                                                        color: 'var(--PrimaryText)',
                                                        '& .MuiInputBase-input': {
                                                            paddingLeft: 0
                                                        },
                                                        '& .MuiInputBase-input:focus': {
                                                            color: 'var(--HighlightedText_Stroke)',
                                                            borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                            backgroundColor: 'transparent',
                                                            fontWeight: '700 !important',
                                                            '& .MuiSvgIcon-root': {
                                                                color: 'var(--HighlightedText_Stroke) !important'
                                                            },
                                                        },
                                                        '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                            color: 'var(--HighlightedText_Stroke)',       //not working
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            color: 'var(--PrimaryText)'
                                                        },
                                                        '& .MuiNativeSelect-select': {
                                                            paddingTop: 0,
                                                            paddingBottom: 0,
                                                        },
                                                        '& .MuiNativeSelect-select option': {
                                                            backgroundColor: 'var(--dropdown-bg) !important',
                                                            fontSize: "18px",
                                                            fontFamily: "Roboto",
                                                            fontWeight: 400,
                                                            color: 'var(--PrimaryText) !important',
                                                            borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                        },
                                                        '& .MuiNativeSelect-select option:checked': {
                                                            backgroundColor: 'var(--dropdown-bg) !important',
                                                            color: 'var(--White) !important',
                                                            fontWeight: '700 !important',
                                                            borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                        },
                                                        '& .MuiInputBase-input option:hover': {
                                                            backgroundColor: '#005D8F !important',
                                                        },
                                                    }}
                                                    MenuProps={{
                                                        PaperProps:{
                                                            sx:{
                                                                width:"160px",
                                                                bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                borderBottom:'2px solid #008CD7',
                                                                borderRadius:0,
                                                                boxShadow:'none',
                                                                maxHeight:'250px',
                                                                overflow:'auto',
                                                                color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                            }
                                                        },               
                                                    }}
                                                value={selectedGroup} onChange={handleGroupChange}>
                                                {Object.keys(groups).map((group) => (
                                                    <MenuItem key={group} value={group}>
                                                    {group}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </div>  
                                <div style={{width:"50%"}}>
                                    {/* Display the selected group's tree */}
                                    {selectedGroup && renderTree(treeData)}
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}>
                            <CustomButton onClick={handleFilterGrouping} buttonText={'Filter'} />
                            <CustomCancelButton onClick={handleCloseGrouping} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>}

                     {<Dialog open={openTagDialog} onClose={() => setOpenTagDialog(false)}
                        BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{'Sort By Group'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Select Tags</Typography>
                                <TagSelection assetdata={assetdata} assetdataerror={assetdataerror} setSelectedTag={setSelectedTags} />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}>
                            <CustomButton onClick={handleFilterTag} buttonText={'Filter'} />
                            <CustomCancelButton onClick={handleCloseFilterTag} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>}

                     {<Dialog open={openDeviceDialog} onClose={() => setOpenDeviceDialog(false)}
                        BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{'Sort By Device'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Select Devices</Typography>
                                <DeviceSelection setSelectedDevices={setSelectedDevices} />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}>
                            <CustomButton onClick={handleFilterDevice} buttonText={'Filter'} />
                            <CustomCancelButton onClick={handleCloseFilterDevice} buttonText={'Cancel'}>
                            </CustomCancelButton>
                        </DialogActions>
                    </Dialog>}

                    {<Dialog open={openGrouping} onClose={() => setGrouping(false)}
                         BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{'Sort By Group'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"25px",marginBottom:"10px"}}>Tree Structure Component</Typography>
                                <div style={{width:"50%", display:"flex", flexDirection:"row"}} gap="30px">
                                                    <FormControl variant="standard" sx={{ marginTop:"0px",marginLeft:"16px"}} fullWidth>
                                                      <InputLabel style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C', fontSize: 18, fontWeight: 400}}>Group Name</InputLabel>
                                                      <Select  labelId="demo-simple-select-standard-label"
                                                                id="demo-simple-select-standard"
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                sx={{
                                                                    "&:before": {
                                                                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                                                    },
                                                                    "&:hover:not(.Mui-disabled):before": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    "&:after": {
                                                                        borderBottom: '2px solid #008CD7',
                                                                    },
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    width: "260px",
                                                                    fontSize: "18px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: '700 !important',
                                                                    color: 'var(--PrimaryText)',
                                                                    '& .MuiInputBase-input': {
                                                                        paddingLeft: 0
                                                                    },
                                                                    '& .MuiInputBase-input:focus': {
                                                                        color: 'var(--HighlightedText_Stroke)',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                                        backgroundColor: 'transparent',
                                                                        fontWeight: '700 !important',
                                                                        '& .MuiSvgIcon-root': {
                                                                            color: 'var(--HighlightedText_Stroke) !important'
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                                        color: 'var(--HighlightedText_Stroke)',       //not working
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'var(--PrimaryText)'
                                                                    },
                                                                    '& .MuiNativeSelect-select': {
                                                                        paddingTop: 0,
                                                                        paddingBottom: 0,
                                                                    },
                                                                    '& .MuiNativeSelect-select option': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        fontSize: "18px",
                                                                        fontFamily: "Roboto",
                                                                        fontWeight: 400,
                                                                        color: 'var(--PrimaryText) !important',
                                                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                                                    },
                                                                    '& .MuiNativeSelect-select option:checked': {
                                                                        backgroundColor: 'var(--dropdown-bg) !important',
                                                                        color: 'var(--White) !important',
                                                                        fontWeight: '700 !important',
                                                                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                                                                    },
                                                                    '& .MuiInputBase-input option:hover': {
                                                                        backgroundColor: '#005D8F !important',
                                                                    },
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps:{
                                                                        sx:{
                                                                            width:"160px",
                                                                            bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                                            borderBottom:'2px solid #008CD7',
                                                                            borderRadius:0,
                                                                            boxShadow:'none',
                                                                            maxHeight:'250px',
                                                                            overflow:'auto',
                                                                            color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                                        }
                                                                    },               
                                                                }}
                                                            value={selectedGroup} onChange={handleGroupChange}>
                                                            {Object.keys(groups).map((group) => (
                                                                <MenuItem key={group} value={group}>
                                                                    {group}
                                                                </MenuItem>
                                                            ))}
                                                      </Select>
                                                    </FormControl>
                                </div>  
                                <div style={{width:"50%"}}>
                                    {/* Display the selected group's tree */}
                                    {selectedGroup && renderTree(treeData)}
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}>
                            <CustomButton onClick={handleFilterGrouping} buttonText={'Filter'} />
                            <CustomCancelButton onClick={handleCloseGrouping} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>}

                    <Dialog
                        open={opencommentDialog}
                        onClose={handleCloseCommentDialog}
                        BackdropProps={{
                            sx:{
                                backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                            }
                        }}
                        sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                    >
                        <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Comments</DialogTitle>
                            <DialogContent >
                                <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                    <TextField
                                            label=""
                                            value={commentadded}
                                            variant="standard"
                                            onChange={(e) =>
                                            setCommentAddedOnAlarm(e.target.value)
                                            }
                                            sx={{
                                                width: '240px',
                                                '& .MuiInputBase-input:focus': {
                                                    color: '#008CD7',
                                                },
                                                '& .MuiInputBase-root': {
                                                    fontFamily: 'Roboto',
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                },
                                                '& .MuiInput-root .MuiInputBase-input': {
                                                    
                                                },
                                                '& .MuiInputBase-root::before': {
                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                },
                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                    borderBottom: '2px solid #008CD7',
                                                },
                                                '& .MuiInputBase-root::after': {
                                                    borderBottom: '2px solid #008CD7',
                                
                                                },
                                            }}
                                        />
                                </DialogContentText>
                            </DialogContent>
                        <DialogActions sx={{justifyContent:'center'}}> 
                            <Button onClick={()=>handleConfirmAddComment(commentadded)} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                Yes
                            </Button>
                            <CustomCancelButton width={"125px"} onClick={handleCloseCommentDialog} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>

                    <CustomDialogBox
                            dialogTitle={"Snooze Alerts"}
                            dialogText={"Snooze configuration saved successfully."}
                            openDialog={openAlarmUpdatedandSaved}
                            handleCloseDialog={handleCloseAlarmUpdatedandSaved}
                            handleConfirmDialog={handleConfirmationAlarmUpdatedandSaved}
                            confirmText={"Ok"}
                            cancelText={"Cancel"}
                            type={"Success"}
                            />
                    <CustomDialogBox
                        dialogTitle={"Snooze Alerts"}
                        dialogText={errMessage}
                        openDialog={errExists}
                        handleCloseDialog={handleCloseErrorDialog}
                        handleConfirmDialog={handleConfirmationErrorDialog}
                        confirmText={"Ok"}
                        cancelText={"Cancel"}
                        type={"Error"}
                        />

                    <CustomDialogBox
                        dialogTitle={"Please select a duration"}
                        dialogText={errMessage}
                        openDialog={errExists}
                        handleCloseDialog={handleCloseErrorDialog}
                        handleConfirmDialog={handleConfirmationErrorDialog}
                        confirmText={"Ok"}
                        cancelText={"Cancel"}
                        type={"Error"}
                        />
                </>
            )}

          

      </>
      
  );
};
